import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=0a46bec2&scoped=true"
import script from "./Forgot.vue?vue&type=script&lang=ts"
export * from "./Forgot.vue?vue&type=script&lang=ts"
import style0 from "./Forgot.vue?vue&type=style&index=0&id=0a46bec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a46bec2",
  null
  
)

export default component.exports